



































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import ErrorLog from '@/components/ErrorLog/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import HeaderSearch from '@/components/HeaderSearch/index.vue'
import Screenfull from '@/components/Screenfull/index.vue'
import SizeSelect from '@/components/SizeSelect/index.vue'
@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    ErrorLog,
    Hamburger,
    HeaderSearch,
    Screenfull,
    SizeSelect
  }
})
export default class extends Vue {
  activeName = AppModule.tabId
  get sidebar () {
    return AppModule.sidebar
  }

  get device () {
    return AppModule.device.toString()
  }

  get avatar () {
    return UserModule.avatar
  }

  get tabDtoList () {
    return UserModule.tabDtoList
  }

  private toggleSideBar () {
    AppModule.ToggleSideBar(false)
  }

  private openMap () {
    this.$router.push('/mapFull')
  }

  private async logout () {
    await UserModule.LogOut()
    this.$router.push(`/login?redirect=${this.$route.fullPath}`).catch(err => {
      console.warn(err)
    })
  }

  private handleClick () {
    // 防止重复点击
    if (this.activeName === AppModule.tabId) return
    AppModule.SetTabId(this.activeName)
    // if (this.$router.path !== '/dashboard') {
    //   this.$router.replace({ path: '/dashboard' })
    // }
    UserModule.ChangeRoles()
  }
}
